import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import Template1 from "../../components/MyEvents/AddEvent/CreateTicket/Templates/TicketTemplate/Template1";
import Ticket5 from "../../components/MyEvents/AddEvent/CreateTicket/Templates/TicketTemplate/Ticket5";
import Ticket6 from "../../components/MyEvents/AddEvent/CreateTicket/Templates/TicketTemplate/Ticket6";
import Ticket7 from "../../components/MyEvents/AddEvent/CreateTicket/Templates/TicketTemplate/Ticket7";
import Ticket8 from "../../components/MyEvents/AddEvent/CreateTicket/Templates/TicketTemplate/Ticket8";
import Ticket9 from "../../components/MyEvents/AddEvent/CreateTicket/Templates/TicketTemplate/Ticket9";
import Band1 from "../../components/MyEvents/AddEvent/CreateTicket/Templates/BandTemplate/Band1";
import Band2 from "../../components/MyEvents/AddEvent/CreateTicket/Templates/BandTemplate/Band2";
import Band3 from "../../components/MyEvents/AddEvent/CreateTicket/Templates/BandTemplate/Band3";
import { Box, Button, Container, Grid } from "@mui/material";
import { useTicketCreationMutation } from "../../Redux/apis/ApiSlice";
import { notification } from "antd";

const ShowTemplates = () => {
  const location = useLocation();
  const eventData = location.state?.eventData || {};
  const selected = eventData?.ticketType;
  const navigate = useNavigate();
  const navigator = "ct";
  const parseDate = (dateString) => {
    const parsedDate = new Date(dateString);
    return isNaN(parsedDate.getTime())
      ? null
      : parsedDate.toISOString().split("T")[0]; // "YYYY-MM-DD"
  };

  const [createTicket, { isLoading }] = useTicketCreationMutation();

  const [selectedTemplate, setSelectedTemplate] = React.useState(null);

  const ticketData = {
    id: 7,
    title: eventData?.eventName || "ROAD TRIP",
    organizer: eventData?.organization || "Taylor Reilly",
    date: eventData?.eventDate || "July 29, 2024",
    time: eventData?.startTime || "02:20 PM",
    // code: "123-456-89",
    location: eventData?.location || "123 Anywhere st., Any City",
    price: eventData?.ticketCategories?.[0]?.price || "0",
    position: "Organizer",
    qrCode: "",
    bgColor: "#E8E8E8",
    endDateTime: eventData?.endDateTime,
    startDateTime: eventData?.startDateTime,
    //
    quantity: eventData?.ticketCategories?.[0]?.quantity || 1,
    ticketCategories: eventData?.ticketCategories || [
      { name: "", price: "", quantity: "" },
    ],
  };

  const ticketData5 = {
    id: 8,
    // code: "123-465-89",
    title: eventData?.eventName || "ART FESTIVAL",
    location: eventData?.location || "123 Anywhere st., Any City",
    price: eventData?.ticketCategories?.[0]?.price || "0",
    position: "Organizer",
    organizer: eventData?.organization || "Taylor Reilly",
    date: eventData?.eventDate || "July 29, 2024",
    endDateTime: eventData?.endDateTime,
    startDateTime: eventData?.startDateTime,
    monthDate: eventData?.eventDate
      ? new Date(eventData.eventDate).toLocaleString("en-US", {
        month: "long",
        day: "numeric",
      })
      : "July 29",
    time: eventData?.startTime || "02:20 PM",
    type: eventData?.ticketType || "VIP",
    bgColor: "#e8e8e8",
    quantity: eventData?.ticketCategories?.[0]?.quantity || 1,
    ticketCategories: eventData?.ticketCategories || [
      { name: "", price: "", quantity: "" },
    ],
  };

  const ticketData6 = { ...ticketData5, id: 9 };

  const ticketData7 = {
    ...ticketData5,
    id: 10,
    code: "0900-78601",
    numberDate: eventData?.eventDate || "21/02/2025",
    organizedBy: `Organized by ${eventData?.organization || "Taylor Reilly"}`,
  };

  const ticketData8 = {
    ...ticketData5,
    id: 11,
    title: eventData?.eventName || "ART FESTIVAL",
    bgColor: "#807C79",
  };

  const ticketData9 = {
    ...ticketData5,
    id: 12,
    bgColor: "#e8753c",
  };

  const bandData1 = {
    ...ticketData5,
    id: 13,
    bgColor: "#807c79",
  };

  const bandData2 = { ...bandData1, id: 14, bgColor: "#00ac4f", };

  const bandData3 = { ...bandData1, id: 15, bgColor: "#b12a2f", };

  const templateItems = [
    { component: Template1, data: ticketData },
    { component: Ticket5, data: ticketData5 },
    { component: Ticket6, data: ticketData6 },
    { component: Ticket7, data: ticketData7 },
    { component: Ticket8, data: ticketData8 },
    { component: Ticket9, data: ticketData9 },
  ];

  const bandItems = [
    { component: Band1, data: bandData1 },
    { component: Band2, data: bandData2 },
    { component: Band3, data: bandData3 },
  ];

  const templatesToRender = selected === "Band" ? bandItems : templateItems;

  const handleClick = (data) => {
    setSelectedTemplate(data);
  };

  const handleSave = async () => {
    if (!selectedTemplate) {
      notification.error({ message: "Please select ticket template" });
      console.error("No template selected!");
      return;
    }
    const payload = {
      eventName: selectedTemplate.title,
      description: selectedTemplate.description,
      location: selectedTemplate.location,
      date: parseDate(selectedTemplate.date),
      startTime: selectedTemplate.time,
      endTime: selectedTemplate.time,
      startDateTime: selectedTemplate.startDateTime,
      endDateTime: selectedTemplate.endDateTime,
      organizationName: selectedTemplate.organizer,
      latitude: 37.7749,
      longitude: -122.4194,
      ticketCategory: eventData.ticketType,
      color: "#FF5733",
      ticketPhoto: "https://example.com/ticket.png",
      ticketTemplate: selectedTemplate.id,
      ticketType: selectedTemplate.ticketCategories.map((category, index) => ({
        ticketTypeId: Number(category.ticketTypeId),
        quantity: Number(category.quantity),
        price: Number(category.price),
      })),
    };

    try {
      const response = await createTicket(payload);
      navigate("/ticket-display", {
        state: { eventData: selectedTemplate, ticketType: selected },
      });
    } catch (error) {
      console.error("Failed to create ticket:", error);
    }
  };
  return (
    <Container>
      <Grid
        container
        spacing={2}
        sx={{ my: "2rem", padding: "0.3rem", overflow: 'hidden' }}
      >
        {templatesToRender.map(
          ({ component: TemplateComponent, data }, index) => (
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6} key={index} sx={{ overflowX: 'auto' }}>
              <div
                style={{
                  height: "100%",
                  border:
                    selectedTemplate?.id === data.id
                      ? "3px solid #1976D2"
                      : "3px solid transparent",
                  borderRadius: "8px",
                  cursor: "pointer",
                  padding: "5px",
                  minWidth: '450px'
                }}
                onClick={() => handleClick(data)}
              >
                <TemplateComponent
                  key={index}
                  navigator={navigator}
                  {...(selected === "Band"
                    ? { ticket: data }
                    : { ticket: data })}
                />
              </div>
            </Grid>
          )
        )}
        
      </Grid>

      <Box sx={{ display: "flex", mb:2, justifyContent: "end", width: "100%" }}>
          <Button
            sx={{
              backgroundColor: "black",
              color: "white",
              width: "20%",
              "&:hover": {
                backgroundColor: "black", // Change to the desired color on hover
                opacity: 0.8, // Add opacity to make it visually appealing
              },
            }}
            onClick={handleSave}
          >
            Save
          </Button>
        </Box>
    </Container>
  );
};

export default ShowTemplates;
